import Config from '@/config.js'
import Socket from '@/socket.js'
import ResizeImageMixin from '@/mixins/slide/ResizeImageMixin'

export default {
  data() {
    return {
      isUploadImageModalShowing: false,
      isCropImageModalShowing: false,
      imageUrl: null,
      cropperData: null,
      isChangingImage: false,
    }
  },
  mixins: [
    ResizeImageMixin,
  ],
  methods: {
    openModalUploadImage(isChangingImage = false) {
      this.isUploadImageModalShowing = true
      this.isChangingImage = isChangingImage
    },
    closeModalUploadImage() {
      this.isUploadImageModalShowing = false
    },
    async handleUploadCroppedImage(formData) {
      return this.$http.post(Config.api.uploadImage, formData)
    },
    async handleUploadLinkImage(imageUrl) {
      return this.$http.post(Config.api.uploadLink, {
        image: imageUrl,
      })
    },
    selectExistImage(attachment) {
      const image = new Image()
      image.src = attachment.thumbnail
      image.onload = () => {
        const imgWidth = image.width
        const imgHeight = image.height
        this.handleCropImageFinished({
          crop: attachment.large,
          raw: null,
          isChangingImage: this.isChangingImage,
          cropperData: {
            cropBoxData: {
              width: imgWidth,
              height: imgHeight,
            },
          },
        })
        this.isUploadImageModalShowing = false
      }
    },
    async handleUpdateGifInBackground(data) {
      const uploadLinkResponse = await this.handleUploadLinkImage(data.imageUrl)
      const s3ImageUrl = uploadLinkResponse.body.file
      const resizedImage = await this.handleResizeImage(s3ImageUrl)
      this.handleCropImageFinished({
        crop: resizedImage.body.origin,
        raw: null,
        isChangingImage: this.isChangingImage,
        cropperData: {
          cropBoxData: data.imageDimension,
        },
      })
      this.isUploadImageModalShowing = false
    },
    createUploadFormData(data) {
      const formData = new FormData()
      formData.append('file', data.file)
      if (data.expires) {
        formData.append('expires', data.expires)
      }
      formData.append('socketId', Socket.getSocketId())
      formData.append('accessCode', data.accessCode)

      return formData
    },
    async handleUpdateInBackground(data) {
      const uploadFormData = this.createUploadFormData(data)
      const uploadRes = await this.handleUploadCroppedImage(uploadFormData)

      const imageUrl = uploadRes.body.file.location
      const resizedImage = await this.handleResizeImage(imageUrl)
      this.handleCropImageFinished({
        slideId: data.selectedSlides[0].id,
        crop: resizedImage.body.origin,
        raw: null,
        isChangingImage: this.isChangingImage,
        cropperData: data.cropperData,
      })
      this.isCropImageModalShowing = false
    },
    async handleResizeImage(imageUrl) {
      if (this.canUseNewResizeImageApi) {
        return this.handleResizeImageWithLambda(imageUrl, { expires: 10 * 365 })
      }
      const extension = imageUrl.split('?')[0].split('.').pop()
      return this.$http.post(Config.api.resizeImage, {
        imageUrl,
        extension,
        expires: 10 * 365,
      })
    },
    async handleUploadFileFinished(imageUrl, source, imageDimension) {
      const extension = imageUrl.split('?')[0].split('.').pop()

      // if it is a gif file then skip the cropping process
      if (extension === 'gif') {
        this.handleCropImageFinished({
          crop: imageUrl,
          raw: null,
          isChangingImage: this.isChangingImage,
          cropperData: {
            cropBoxData: imageDimension,
          },
        })
        this.isUploadImageModalShowing = false
      } else {
        this.cropperData = null
        this.isCropImageModalShowing = true
        this.isUploadImageModalShowing = false
        this.imageUrl = imageUrl
      }
    },

    handleCancelCrop() {
      this.isCropImageModalShowing = false
      this.isUploadImageModalShowing = true
    },
  },

}
